module.exports = __webpack_public_path__ + "img/kas_masuk.40eaf988.png";